import React, { Component } from "react";
import "./SignIn.css";
import MMCL_Logo from "../static/images/MMCL_Logo.webp";
import axios from "../api/axios";
import { toast } from "react-toastify";
import hideElements from '../utility/Tools.js';

let activeStatus = false;

async function Login() {
  const signin_url="login/"
  
  let email = document.getElementById('inputEmail').value;
  let pwd = document.getElementById('inputPassword').value;
  const toastId = toast.loading('Logging in'); 
            try {
                var response = await axios.post(signin_url, JSON.stringify({ email, pwd }),
                    {
                        headers: { "Content-Type": "application/json" },
                    }
                );
                setTimeout(function () {
                var data = JSON.stringify(response.data);
                var token=JSON.parse(data).token;
                localStorage.setItem("token",token);
                  window.location.href = '/ApplicantStatus';
              }, 3000);
                //redirect
                  }catch (err){
                    var data = JSON.stringify(err.response.data);
                    var statusCode = err.response.status;
                    var statusMessage=JSON.parse(data).status;
                    toast.update(toastId, {
                      render: statusMessage,
                      type: 'error',
                      isLoading: false,
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                  })
                  if(statusMessage ==="Account not activated"){
                    hideElements();
                    document.getElementById('resend-activation').style.display="block";
                    }
                  }
  }

function activateAccount() {
  let paramString = new URL(document.location).searchParams;
  let code = paramString.get("code");
  let email = paramString.get("email");
try {
    const response = axios.patch("activate/" + code + "/" + email);
    activeStatus = true;
      toast.success('Account activated.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      //Insert success message here
  }catch (err) {
    var data = JSON.stringify(err.response.data);
                    var statusCode = err.response.status;
                    var statusMessage=JSON.parse(data).status;
    toast.error(statusMessage, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
  }
}

function ifAccountActive() {
    if (activeStatus == true) {
        hideElements();
        document.getElementById("signInHeader").innerText = "Your Account Has Been Activated!";
        document.getElementById("signInText").innerText = "You will now be redirected to the Sign In page.";
        setTimeout(function () {
            window.location.href = '/sign-in';
        }, 5000);
    }
}

window.onload = ifAccountActive;

export class SignIn extends Component {
  static displayName = SignIn.name;

  //Need to edit code for checking if link is from email
componentDidMount(){
  if (window.location.href.indexOf("code") > -1) {  
    activateAccount();
  }

  document.getElementById("inputEmail").addEventListener("keypress", function(event){
    if(event.key==="Enter"){
      event.preventDefault();
      document.getElementById("btnSignIn").click();
    }
  })

  document.getElementById("inputPassword").addEventListener("keypress", function(event){
    if(event.key==="Enter"){
      event.preventDefault();
      document.getElementById("btnSignIn").click();
    }
  })
  document.getElementById('btnHome').style.visibility="visible";
}

  render() {
    return (
      <div className="sign-in">
        <div className="card sign-in-card">
          <form>
            <div className="sign-in-logo-container text-center">
              <img src={MMCL_Logo} className="sign-in-logo" alt="MMCL Logo" />
            </div>
            <h3 id="signInHeader" className="text-center mt-10 b-10">SIGN IN</h3>
            <p id="signInText" class="text-center mt-5 mb-5"></p>
            <div className="form-outline mb-4 hiding-elements">
              <label className="form-label" for="inputEmail">
                Email address
              </label>
              <input type="email" id="inputEmail" className="form-control" />
            </div>
            <div className="form-outline mb-4 hiding-elements">
              <label className="form-label" for="inputPassword">
                Password
              </label>
              <input
                type="password"
                id="inputPassword"
                className="form-control"
              />
            </div>
            <div className="row mb-4 hiding-elements">
              <div className="col">
                <a href="change-password-email" className="sign-in-link links">
                  Forgot password?
                </a>
              </div>
            </div>
            <div className="text-center hiding-elements">
              <button id="btnSignIn"
                type="button"
                className="btn btn-block mb-4 sign-in-button"
                onClick={() => Login()}
              >
                Sign in
              </button>
            </div>
            <div className="text-center hiding-elements">
              <p>
                Don't have an account yet?{" "}
                <a href="/sign-up" className="links sign-in-link">
                  Sign up using your registered email address
                </a>
              </p>
              
            </div>
            <div id="resend-activation" className="text-center resend-activation">
                Didn't receive a verification email?{" "}
                <a href="/resend-email" className="links sign-in-link">
                  Resend
                </a>
                <a href="/sign-in" className="links sign-up-link">← Go back to Sign in</a>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
